export { default as Person } from '@components/person/Person';



// WEBPACK FOOTER //
// ./src/components/person/index.ts